import { useTheme } from 'styled-components';

import { Money } from '@dreryk/money-common-api';

import { Text } from '@dreryk/react-components';
import { useTranslate } from '@dreryk/react-common';

import { advancePaymentStatusVisitor } from '../shared/advancePaymentStatusVisitor';
import { translationKeys } from '../translations';

import { getOverpaymentLabel, getUnderpaymentLabel } from './AdvancePaymentNotification.utils';

type AdvancePaymentStatusTextProps = {
   className?: string;
   readonly paidAmount: Money;
   readonly requiredAmount: Money;
};

export const AdvancePaymentStatusText = (props: AdvancePaymentStatusTextProps): JSX.Element | null => {
   const theme = useTheme();
   const translate = useTranslate();

   return advancePaymentStatusVisitor(props, {
      visitPaid: () => null,
      visitUnderpayment: () => (
         <Text className={props.className} color={theme.errorDark} testId={'visitUnderpayment'}>
            {translate(
               getUnderpaymentLabel(
                  translationKeys.advancePaymentUnderpaymentText,
                  props.paidAmount,
                  props.requiredAmount
               )
            )}
         </Text>
      ),
      visitOverpayment: () => (
         <Text className={props.className} color={theme.warningDark} testId={'visitOverpayment'}>
            {translate(
               getOverpaymentLabel(
                  translationKeys.advancePaymentOverpaymentText,
                  props.paidAmount,
                  props.requiredAmount
               )
            )}
         </Text>
      ),
   });
};
